<template>
    <div class="about">
        <h1 class="h1 text-center">Дидактичні матеріали для опрацювання</h1>

        <div class="row">
            <div class="col-4 mx-auto">
                <video-search @afterVideoSearch="afterVideoSearch"></video-search>
            </div>
        </div>

        <video-widget :videoPackageItem="videoPackageItem"></video-widget>
    </div>
</template>

<script>
    export default {
        name: 'junior-home-page',
        data() {
            return {
                videoPackageItem: {}
            }
        },
        methods: {
            afterVideoSearch(videoPackageItem) {
                if (!videoPackageItem) {
                    //alert("Матеріал за вказаним кодом не знайдено!");
                    this.$notify({type: 'error', duration: 10000, text: `Матеріал за вказаним кодом не знайдено!`});
                }

                this.videoPackageItem = videoPackageItem;
                console.log('afterVideoSearch in junior-student-cabinet', videoPackageItem);
            }
        }
    }
</script>
